var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.4887 7L13.6991 1.78955C13.8933 1.59146 14.0014 1.32476 14 1.04741C13.9986 0.770052 13.8878 0.504457 13.6917 0.308335C13.4955 0.112214 13.2299 0.00141426 12.9526 1.34449e-05C12.6752 -0.00138737 12.4085 0.106724 12.2104 0.300854L7 5.5113L1.78955 0.300854C1.59146 0.106724 1.32476 -0.00138737 1.04741 1.34449e-05C0.770052 0.00141426 0.504457 0.112214 0.308335 0.308335C0.112214 0.504457 0.00141426 0.770052 1.34449e-05 1.04741C-0.00138737 1.32476 0.106724 1.59146 0.300854 1.78955L5.5113 7L0.300854 12.2104C0.106724 12.4085 -0.00138737 12.6752 1.34449e-05 12.9526C0.00141426 13.2299 0.112214 13.4955 0.308335 13.6917C0.504457 13.8878 0.770052 13.9986 1.04741 14C1.32476 14.0014 1.59146 13.8933 1.78955 13.6991L7 8.4887L12.2104 13.6991C12.4085 13.8933 12.6752 14.0014 12.9526 14C13.2299 13.9986 13.4955 13.8878 13.6917 13.6917C13.8878 13.4955 13.9986 13.2299 14 12.9526C14.0014 12.6752 13.8933 12.4085 13.6991 12.2104L8.4887 7Z",
    fill: "#EA3A3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.00e80938883ddcd343ea01c05d54d72e.svg";
export { ForwardRef as ReactComponent };